import Post from "../Post";
import getToken from "../token";

export default function setResponseDay(day, start, end) {
  return Post("doctor/responseDay", {
    token: getToken(),
    dayName: day,
    timeStart: start,
    timeEnd: end,
  });
}
